import { auth } from "../firebase-config";

export function isAdmin() {
    const user = auth.currentUser
    return user !== null;
}